import React from 'react';
import styles from './Footer.styles.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.footer)}>
      <div className="row">
        <div className="col-12 text-center">
          <p className={styles.copyright}>
            {t('footer_copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Footer);
